"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var bind_1 = require("../bind");
var tokenized_credit_card_hidden_fields_1 = require("./tokenized_credit_card_hidden_fields");
var CreditCardHtmlForm = /** @class */ (function (_super) {
    tslib_1.__extends(CreditCardHtmlForm, _super);
    function CreditCardHtmlForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            cardData: {
                cardholderName: props.user.name || '',
                cardType: '',
                last4: '',
            },
            tokenizedFields: {
                encryptedSecurityCode: '',
                encryptedExpiryMonth: '',
                encryptedExpiryYear: '',
                encryptedCardNumber: '',
            },
        };
        return _this;
    }
    CreditCardHtmlForm.prototype.onFieldUpdate = function (newTokenizedFields) {
        var tokenizedFields = tslib_1.__assign(tslib_1.__assign({}, this.state.tokenizedFields), newTokenizedFields);
        this.setState({ tokenizedFields: tokenizedFields });
    };
    CreditCardHtmlForm.prototype.onCardDataUpdate = function (newCardData) {
        var cardData = tslib_1.__assign(tslib_1.__assign({}, this.state.cardData), newCardData);
        this.setState({ cardData: cardData });
    };
    CreditCardHtmlForm.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(form_group_with_input_1.default, { inputName: "credit_card[cardholder_name]", label: I18n.t('discovery.creditCardForm.nameOnCard'), value: this.state.cardData.cardholderName, updateField: this.onCardDataUpdate, fieldName: "cardholderName", required: true }),
            React.createElement(tokenized_credit_card_hidden_fields_1.default, { onTokenizedFieldUpdate: this.onFieldUpdate, onCardDataUpdate: this.onCardDataUpdate, tokenizedFields: this.state.tokenizedFields, cardData: this.state.cardData })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CreditCardHtmlForm.prototype, "onFieldUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], CreditCardHtmlForm.prototype, "onCardDataUpdate", null);
    return CreditCardHtmlForm;
}(React.Component));
exports.CreditCardHtmlForm = CreditCardHtmlForm;
exports.default = user_context_provider_1.withUserContext(CreditCardHtmlForm);
//# sourceMappingURL=credit_card_html_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/credit_card_html_form.js
// module id = 3ImO
// module chunks = 20 21 22